
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-check)"}},[_c('path',{attrs:{"d":"M18.444 6.333L8.42 16.356a1.902 1.902 0 01-2.689 0L.557 11.18a1.902 1.902 0 012.689-2.689l3.83 3.83 8.678-8.678a1.902 1.902 0 012.69 2.69z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-check"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h19v19H0z"}})])])])
          )
        }
      }
    